import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';

export const Wrapper = styled.div`
  position: relative;
  z-index: 99999;
  width: 100vw;
  margin: 85px 0px 0px;

  ${media.md`
    margin: 88px 0px 0px;
  `}

  ${media.xl`
    margin: 90px 0px 0px;
  `}
`;
